import close from "assets/images/black-close-button.svg";
import mobileUploadPlaceholder from "assets/images/mobile-upload-placeholder.svg";
import uploadPlaceholder from "assets/images/upload-image-placeholder.svg";
import classNames from "classnames";
import React, {useEffect, useRef, useState} from "react";
import {dragAndDropFileUpload as strings} from "strings";

import styles from "./DragAndDropFileUpload.module.css";

export default function DragAndDropFileUpload(props: {
  className?: string;
  existingImage?: File | undefined;
  onUpload: (file: File | undefined) => void;
}) {
  const {className, onUpload} = props;
  const fileInputField = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | undefined>(props.existingImage);
  const [dragActive, setDragActive] = useState(false);

  const handleDrag = (e: React.DragEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

  const handleClick = () => {
    if (fileInputField && fileInputField.current) {
      fileInputField.current.click();
    }
  };

  const handleChange = function (e: React.ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  useEffect(() => {
    onUpload(file);
  }, [file, onUpload]);

  const previewImage = file ? URL.createObjectURL(file) : undefined;

  return (
    <form
      className={classNames(styles.form, className)}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
      onSubmit={(e) => e.preventDefault()}
    >
      <input
        className={styles.hidden}
        type="file"
        ref={fileInputField}
        title=""
        value=""
        accept="image/*"
        capture
        onChange={(e) => {
          handleChange(e);
        }}
      />
      <button
        onClick={handleClick}
        className={classNames(styles.input, dragActive && styles.dragActive)}
      >
        <img
          src={previewImage ?? uploadPlaceholder}
          alt=""
          className={classNames(
            styles.img,
            styles.web,
            !previewImage && styles.placeholder,
          )}
        />
        <img
          src={previewImage ?? mobileUploadPlaceholder}
          alt=""
          className={classNames(
            styles.img,
            styles.mobile,
            !previewImage && styles.placeholder,
          )}
        />
      </button>
      {previewImage ? (
        <button
          className={styles.close}
          onClick={(e) => {
            e.stopPropagation();
            setFile(undefined);
          }}
        >
          <img src={close} alt={strings.remove} />
        </button>
      ) : null}
    </form>
  );
}
